// CALL AXIOS TO CONSUME WEB SERVICE
import axios from "axios"
import authHeader from "../authentification/AuthHeader";

//GET URL FROM .ENV ELEMENT
import { getUrl } from "../authentification/DotenvConfig"

/**
 * URL OF APP 
 * EXAMPLE : https://exemple/api/v1
 */
const url = getUrl()


export async function verifCodePromo(data) {
    try {
        const response = await axios.post(url + "promo/byCode/" , data, { headers: authHeader() }, {
            IsEssential: true
        });
        console.log("promotion")
        console.log("promotion")
        console.log("promotion")
        console.log("promotion")
        console.log("promotion",response)
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}
export async function findById(id) {
    try {
        const response = await axios.post(url + "promo/" , id, { headers: authHeader() }, {
            IsEssential: true
        });
        console.log("pppp")
        console.log("pppp")
        console.log("pppp")
        console.log("pppp")
        console.log("pppp",response)
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}